'use client'
import WideBox from './WideBox'

import { VictoryChart, VictoryBar, VictoryAxis } from 'victory'

type ChartBoxProps = {
  animationProps: any
  title: string
  barValues: Array<{ x: string; y: number }>
  barColor?: string
  highlightBarColor?: string
  hightlightedBar: string
  tickValues: Array<number>
}
const ChartBox = ({
  title,
  animationProps,
  barValues,
  tickValues,
  hightlightedBar,
  highlightBarColor = '#266782',
  barColor = '#aadbd7',
}: ChartBoxProps) => {
  return (
    <WideBox animationProps={animationProps} title={title}>
      <div className="relative ml-4 w-full">
        <VictoryChart domainPadding={{ x: [30, 10] }}>
          <VictoryBar
            style={{
              data: {
                fill: ({ datum }: any) =>
                  datum.x === hightlightedBar ? highlightBarColor : barColor,
              },
            }}
            data={barValues}
          />
          <VictoryAxis
            dependentAxis
            standalone={false}
            tickValues={tickValues}
            tickFormat={(t: any) => `${Math.round(t)}M`}
          />
          <VictoryAxis crossAxis standalone={false} orientation="bottom" />
        </VictoryChart>
      </div>
    </WideBox>
  )
}

export default ChartBox
